import React from 'react'

const Devider = () => {
  return (
    <div className='p-[0.5px] bg-slate-200 my-2'></div>
  )
}

export default Devider